import { defineMessages } from "react-intl";

export const messages = defineMessages({
    industrySelectorTitle: {
        id: "UsageBasedPricing.IndustrySelector.title",
        defaultMessage: "What type of work does your team do?"
    },
    industrySelectorSubtitle: {
        id: "UsageBasedPricing.IndustrySelector.subtitle",
        defaultMessage: "Work types are based on our collections."
    },
    teamCollaboration: {
        id: "UsageBasedPricing.IndustrySelector.teamCollaboration",
        defaultMessage: "Team Collaboration"
    },
    strategyPlanning: {
        id: "UsageBasedPricing.IndustrySelector.strategyPlanning",
        defaultMessage: "Strategy & Planning"
    },
    serviceManagement: {
        id: "UsageBasedPricing.IndustrySelector.serviceManagement",
        defaultMessage: "Service Management"
    },
    softwareDevelopment: {
        id: "UsageBasedPricing.IndustrySelector.softwareDevelopment",
        defaultMessage: "Software Development"
    },
    learnMoreLink: {
        id: "UsageBasedPricing.IndustrySelector.learnMore",
        defaultMessage: "Collections"
    }
});
